export default "__VITE_ASSET__CCBSq6Dg__"